<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :selection="false"
      label-width="100px"
    />
  </div>
</template>

<script>
// import x from ''
import fieldFilter from '@/utils/fieldFilter.js'
export default {
  name: 'Piaowuguanli',
  components: {},
  data() {
    return {
      url: '/business/tax/page?unit=false',
      columns: [
        {
          label: '公司名称',
          prop: 'companyName'
        },
        {
          label: '税号',
          prop: 'taxNo'
        },
        {
          label: '发票形式',
          prop: 'invoiceForm',
          template: (index, record) => {
            return record.invoiceForm == '0' ? '增值税普通发票' : '增值税专用发票'
          }
        },
        {
          label: '开户行名称',
          prop: 'openBankName'
        },
        {
          label: '开户行账号',
          prop: 'openBankAccountNo'
        },
        {
          label: '注册地址',
          prop: 'registerAddress'
        },
        {
          label: '电话',
          prop: 'mobile'
        },
        {
          label: '创建时间',
          prop: 'createTime'
        }
      ],
      // 操作栏
      handles: {
        width: 80,
        btns: [
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'finance.ticketing.update',
            handle: resp => {
              this.$router.push({ path: './ticketModification', query: { data: resp }})
            }
          }
        ]
      },
      query: [
        {
          label: '公司名称',
          prop: 'companyName',
          placeholder: '请输入公司名称'
        },
        {
          label: '税号',
          prop: 'taxNo',
          placeholder: '请输入税号'
        },
        {
          label: '开户行名称',
          prop: 'openBankName',
          placeholder: '请输入开户行名称'
        },
        {
          label: '开户行账号',
          prop: 'openBankAccountNo',
          placeholder: '请输入开户行账号'
        },
        {
          label: '注册地址',
          prop: 'registerAddress',
          placeholder: '请输入注册地址'
        },
        {
          label: '电话',
          prop: 'mobile',
          placeholder: '请输入电话'
        }
      ],
      dialogVisible: false,
      rowdata: {
        accountInfo: {},
        connectorInfo: {},
        payInfo: {}
      }
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    // this.$store.dispatch("form/handle", {
    //   url: "/station/getOperators",
    //   callback: resp => {
    //     this.query[8].data = resp.list;
    //   }
    // });
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    getPayType: payType => {
      if (!payType) return ''
      if (payType == -1) return '支付失败'
      if (payType == 0) return '充电中待支付'
      if (payType == 1) return '企业钱包'
      if (payType == 2) return '个人钱包'
      if (payType == 3) return '企业钱包+个人钱包'
    },
    getStartChargeSeqStat: startChargeSeqStat => {
      if (!startChargeSeqStat) return ''
      if (startChargeSeqStat == 1) return '启动中'
      else if (startChargeSeqStat == 2) return '充电中'
      else if (startChargeSeqStat == 3) return '停止中'
      else if (startChargeSeqStat == 4) return '已结束'
      else return '未知'
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
.detail {
  .item {
    width: 33%;
    height: 50px;
    float: left;
    border: 1px solid #dddddd;
    text-align: center;

    .label {
      width: 100px;
      height: 50px;
      float: left;
      background: #dddddd;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      color: #000;
    }

    .value {
      // line-height: 50px;
      font-size: 14px;
      margin-top: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .value:hover {
      height: auto;
      white-space: normal;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/ticketmanagement.vue